<template>
  <div class="nre-barcode-container">
    <!-- Primo codice a barre -->
    <div class="barcode-block">
      <canvas ref="barcode1"></canvas>
      <div class="barcode-text">*{{ nrePart1 }}*</div>
    </div>

    <!-- Secondo codice a barre -->
    <div class="barcode-block">
      <canvas ref="barcode2"></canvas>
      <div class="barcode-text">*{{ nrePart2 }}*</div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  name: 'NreBarcode',
  props: {
    nre: {
      type: String,
      required: true
    }
  },
  computed: {
    nrePart1() {
      return this.nre.slice(0, 5);
    },
    nrePart2() {
      return this.nre.slice(5);
    }
  },
  mounted() {
    JsBarcode(this.$refs.barcode1, this.nrePart1, {
      format: "CODE39",
      height: 28.35, // 8mm
      width: 1.1,
      displayValue: false,
      margin: 0
    });

    JsBarcode(this.$refs.barcode2, this.nrePart2, {
      format: "CODE39",
      height: 28.35,
      width: 1.1,
      displayValue: false,
      margin: 0
    });
  }
};
</script>

<style scoped>
.nre-barcode-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}

.barcode-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.barcode-text {
  font-size: 12pt;
  font-family: monospace;
  margin-top: 2px;
}
</style>
